import './EmptyState.css';

/** Estado vacío con ícono, mensaje y acción opcional. */
export default function EmptyState({ icon, title, children, action }) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-state-icon" aria-hidden="true">{icon}</div>}
      {title && <p className="empty-state-title">{title}</p>}
      {children}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}